import { render, staticRenderFns } from "./FacebookMessageBox.vue?vue&type=template&id=5a86a1d2&"
import script from "./FacebookMessageBox.vue?vue&type=script&lang=js&"
export * from "./FacebookMessageBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports